import type { ButtonProps } from '@chakra-ui/react'
import { Button } from '@chakra-ui/react'
import React from 'react'

import { Pdf } from '../icons'

interface DownloadButtonOwnProps<T extends React.ElementType> extends ButtonProps {
  isDownloadAll?: boolean
  as?: T
}

type DownloadButtonProps<T extends React.ElementType> = DownloadButtonOwnProps<T> & Omit<React.ComponentProps<T>, keyof DownloadButtonOwnProps<T>>

export const DownloadButton = <T extends React.ElementType>({ children, sx, isDownloadAll = false, ...rest }: DownloadButtonProps<T>) => {
  return (
    <Button
      type="button"
      variant="ghost"
      sx={{
        px: 4,
        py: isDownloadAll ? 4 : 1,
        gap: 2,
        fontWeight: isDownloadAll ? 'medium' : 'normal',
        whiteSpace: 'normal',
        ...sx,
      }}
      {...rest}
    >
      <Pdf color="secondary.500" />
      {children}
    </Button>
  )
}
